import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import Header from "../../components/Header";
import { Form, Button, Row, Col, Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { AuthToken, AuthToken2, BASE_URL, BASE_URL2 } from "../../api/base";
import VideoPlayer from "./LecturePlay/VideoPlayer";
import { getUserIp } from "../../api/thirdparty";
import "./Lectures.css"
import VideoCipherPlayer from "./LecturePlay/VideoCipherPlayer";
import VideoPlayModal from "./LecturePlay/VideoCipherSupport";
import { FaPlay, FaVideo } from "react-icons/fa";


const Lectures = () => {
    const { courseid, coursename } = useParams();
    const [lectures, setLectures] = useState([]);
    const [selectedTab, setSelectedTab] = useState("live");
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedLecture, setSelectedLecture] = useState(null);
    const [videoUrl, setVideoUrl] = useState("");
    const [ipaddress, setIpaddress] = useState("");
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [otp, setOtp] = useState("")
    const [playbackInfo, setplaybackInfo] = useState("")
    const [playVideoModal, setPlayVideoModal] = useState(false);
    // Replace your current single modal state for clarity
    const [showLiveModal, setShowLiveModal] = useState(false);      // for live lectures
    const [showRecordedModal, setShowRecordedModal] = useState(false); // for recorded lectures


    const affname1 = localStorage.getItem("AffiliateName") || "";
    const affmobile2 = localStorage.getItem("Mobile") || "";
    const affemail3 = localStorage.getItem("EmailID") || "";
    const aff4id = localStorage.getItem("ClassAffiliateID") || "";


    // Fetch lectures
    useEffect(() => {
        const fetchLectures = async () => {
            setLoading(true);
            try {
                let url;
                let body = { course_id: courseid };

                if (selectedTab === "live") {
                    url = `${BASE_URL2}/live-lectures`;
                } else if (selectedTab === "course") {
                    url = `${BASE_URL2}/course-lectures`;
                } else if (selectedTab === "recorded") {
                    url = `${BASE_URL2}/recorded-lectures`;
                    body = { course_id: courseid, page, limit: sizePerPage };
                }

                const res = await fetch(url, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", API_Key: AuthToken2 },
                    body: JSON.stringify(body),
                });

                const data = await res.json();

                if (selectedTab === "live") {
                    setLectures(data.data.lectures || []);
                } else if (selectedTab === "course") {
                    setLectures(data.data.courseLectures || []);
                } else if (selectedTab === "recorded") {
                    setLectures(data.data.lectures || []);
                    setTotalRecords(data.data.count || 0);
                }
            } catch (err) {
                console.error("Error fetching lectures:", err);
            }
            setLoading(false);
        };

        fetchLectures();
    }, [selectedTab, courseid, page, sizePerPage]);


    const fetchLectures = async (selectedTabValue = selectedTab, pageValue = page) => {
        setLoading(true);
        try {
            let url;
            let body = { course_id: courseid };

            if (selectedTabValue === "live") {
                url = `${BASE_URL2}/live-lectures`;
            } else if (selectedTabValue === "course") {
                url = `${BASE_URL2}/course-lectures`;
            } else if (selectedTabValue === "recorded") {
                url = `${BASE_URL2}/recorded-lectures`;
                body = { course_id: courseid, page: pageValue, limit: sizePerPage };
            }

            const res = await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json", API_Key: AuthToken2 },
                body: JSON.stringify(body),
            });

            const data = await res.json();

            if (selectedTabValue === "live") {
                setLectures(data.data.lectures || []);
            } else if (selectedTabValue === "course") {
                setLectures(data.data.courseLectures || []);
            } else if (selectedTabValue === "recorded") {
                setLectures(data.data.lectures || []);
                setTotalRecords(data.data.count || 0);
            }
        } catch (err) {
            console.error("Error fetching lectures:", err);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchLectures(selectedTab, 1);
        setPage(1);
    }, [selectedTab, courseid]);


    // Fetch IP for watermark
    useEffect(() => {
        const fetchIp = async () => {
            try {
                const { data } = await getUserIp();
                setIpaddress(data.ip);
            } catch {
                setIpaddress("IP not available");
            }
        };
        fetchIp();
    }, []);

    const handleJoinClick = (lecture) => {
        setSelectedLecture(lecture);
        setVideoUrl(""); // reset previous video
        setShowModal(true);
    };

    const handlePlayLecture = async () => {
        if (!selectedLecture) return;
        console.log("se", selectedLecture);


        if (selectedTab === "live") {
            // existing live lecture logic
            const payload = {
                liveLectureID: selectedLecture.liveLectureID,
                courseId: courseid,
                IPAddress: ipaddress,
            };
            const res = await fetch(`${BASE_URL2}/live-lecture-details`, {
                method: "POST",
                headers: { "Content-Type": "application/json", API_Key: AuthToken2 },
                body: JSON.stringify(payload),
            });
            const data = await res.json();
            const hlsUrl = data.data.liveDetails.channel.link || "";
            setVideoUrl(hlsUrl);
        } else {
            // Recorded lecture logic: call the GetVideoCiper API
            console.log("selectedlecture", selectedLecture);

            try {
                const payload = {
                    lectureid: selectedLecture?.VideoFile, // send the selected lecture ID
                    userid: aff4id, // optional
                    mobile: affmobile2,
                    EmailID: affemail3,
                    IPAddress: ipaddress
                };

                const res = await fetch(
                    `${BASE_URL}/GetVideoCiper`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "API_Key": AuthToken,
                        },
                        body: JSON.stringify(payload),
                    }
                );

                const data = await res.json();

                if (data?.Otp && data?.PlaybackInfo) {
                    // Construct the video URL according to your player requirements
                    setVideoUrl(data?.Otp)
                    setplaybackInfo(data?.PlaybackInfo)
                    setOtp(data?.Otp)
                    setPlayVideoModal(true)

                } else {
                    // alert("Video not available.");
                }
            } catch (err) {
                console.error("Error fetching recorded video:", err);
                alert("Failed to fetch video. Please try again.");
            }
        }
    };



    // Filter lectures by search term
    const filteredLectures = lectures.filter((lec) =>
        lec.LectureTitle.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Columns for react-bootstrap-table-next
    const columns = [
        {
            dataField: "index",
            text: "Srno",
            formatter: (cell, row, rowIndex) => (page - 1) * sizePerPage + rowIndex + 1,
            headerStyle: { width: "50px", textAlign: "center" },
            style: { textAlign: "center" },
        },
        {
            dataField: "LectureTitle",
            text: "Lecture Title",
            formatter: (cell, row) => row.LectureTitle,
            sort: true,
            headerStyle: { width: "250px" },
            style: { whiteSpace: "normal", wordWrap: "break-word" },
        },
        {
            dataField: "Teacher",
            text: "Teacher",
            formatter: (cell, row) => row.teacher?.TeacherName || "N/A",
            sort: true,
            headerStyle: { width: "180px" },
        },
        {
            dataField: "ScheduleDate",
            text: "Schedule Date",
            formatter: (cell, row) =>
                new Date(row.ScheduleDate).toLocaleDateString("en-GB", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                }),
            sort: true,
            headerStyle: { width: "150px" },
        },
        {
            dataField: "StartTime",
            text: "Start Time",
            formatter: (cell, row) => row.StartTime,
            sort: true,
            headerStyle: { width: "120px" },
        },
        {
            dataField: "EndTime",
            text: "End Time",
            formatter: (cell, row) => row.EndTime,
            sort: true,
            headerStyle: { width: "120px" },
        },
        {
            dataField: "Actions",
            text: "Action",
            formatter: (cell, row) => {
                const scheduleDate = new Date(row.ScheduleDate);
                const [startHour, startMin] = (row.StartTime ?? "00:00").split(":").map(Number);
                const [endHour, endMin] = (row.EndTime ?? "23:59").split(":").map(Number);

                const startTime = new Date(scheduleDate);
                startTime.setHours(startHour, startMin, 0);

                const endTime = new Date(scheduleDate);
                endTime.setHours(endHour, endMin, 0);

                const currentTime = new Date();

                const canJoin =
                    scheduleDate.getDate() === currentTime.getDate() &&
                    currentTime >= startTime &&
                    currentTime <= endTime;

                return canJoin ? (
                    <Button size="sm" variant="info" className="px-2 py-1 play-inline-btn d-flex align-items-center gap-2 btn btn-info btn-sm"
                    style={{backgroundColor:"#0d6efd", color:"white"}}
                    onClick={() => {
                        setSelectedLecture(row);
                        setVideoUrl("");
                        setShowLiveModal(true);
                        
                    }}>
                        <FaVideo className="me-1" />
                        Join
                    </Button>
                ) : (
                    <span style={{ color: "blue" }}>N/A</span>
                );
            },

            headerStyle: { width: "100px", textAlign: "left" },
            style: { textAlign: "center" },
        }

    ];

    const columnsRecorded = [
        {
            dataField: "index",
            text: "Srno",
            formatter: (cell, row, rowIndex) => (page - 1) * sizePerPage + rowIndex + 1,
            headerStyle: { width: "50px", textAlign: "center" },
            style: { textAlign: "center" },
        },
        {
            dataField: "LectureTitle",
            text: "Lecture Title",
            formatter: (cell, row) => row.LectureTitle,
            sort: true,
            headerStyle: { width: "250px" },
            style: { whiteSpace: "normal", wordWrap: "break-word" },
        },
        {
            dataField: "Teacher",
            text: "Teacher",
            formatter: (cell, row) => row.users?.TeacherName || "N/A",
            sort: true,
            headerStyle: { width: "180px" },
        },
        {
            dataField: "ScheduleDate",
            text: "Date",
            formatter: (cell, row) =>
                new Date(row.ShceduleDate).toLocaleDateString("en-GB", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                }),
            sort: true,
            headerStyle: { width: "150px" },
        },
        {
            dataField: "Duration",
            text: "Duration (min)",
            formatter: (cell, row) => row.Duration,
            sort: true,
            headerStyle: { width: "120px" },
        },
        {
            dataField: "Actions",
            text: "Action",
            formatter: (cell, row) => (
                <Button
                    size="sm"
                    variant="success"
                    className="recorded_play_button"
                    
                    onClick={() => {
                        setSelectedLecture(row);   // set lecture first
                        setVideoUrl("");           // reset previous video
                        setShowRecordedModal(true); // open modal -> triggers useEffect
                    }}
                >
                                    
                                    <FaPlay size={14} />
                    Play Lecture
                </Button>


            ),
            headerStyle: { width: "100px", textAlign: "center" },
            style: { textAlign: "center" },
        },
    ];


    useEffect(() => {
        setPage(1); // reset page when tab changes
    }, [selectedTab]);

    useEffect(() => {
        if (showRecordedModal && selectedLecture) {
            handlePlayLecture(); // automatically fetch OTP and video
        }
    }, [showRecordedModal, selectedLecture]);



    return (
        <div>
            <Header />
            <div className="container courses-container">
                <h2 className="mb-2">Lectures</h2>

                <span style={{ color: "#8094ae", fontSize: "17px", marginTop: "5px" }}>{coursename}</span>
                {/* Tabs */}
                <div className="d-flex mb-3" style={{ marginTop: "15px" }}>
                    <Button
                        variant={selectedTab === "live" ? "primary" : "outline-primary"}
                        className="me-2"
                        onClick={() => setSelectedTab("live")}
                    >
                        Live Lectures
                    </Button>
                    <Button
                        variant={selectedTab === "recorded" ? "primary" : "outline-primary"}
                        onClick={() => setSelectedTab("recorded")}
                    >
                        Course Lectures
                    </Button>

                </div>

                {/* Search */}
                <Row className="mb-3">
                    <Col md={4}>
                        <Form.Control
                            type="text"
                            placeholder="Search by lecture title..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </Col>
                </Row>

                {/* Table */}
                {/* Table */}
                <div className="position-relative">
                    {loading && (
                        <div className="loading-overlay">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}

                    {filteredLectures.length > 0 ? (

                        <>
                            <BootstrapTable
                                keyField={selectedTab === "live" ? "liveLectureID" : "LectureID"}
                                data={filteredLectures}
                                columns={selectedTab === "recorded" ? columnsRecorded : columns}
                                bordered={false}
                                hover
                                condensed
                            />

                            {/* Custom Pagination */}
                            {/* Custom Pagination Controls */}
                            {selectedTab === "recorded" && (
                                <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">

                                    {/* Left: Rows per page */}
                                    <div className="d-flex align-items-center">
                                        <span className="me-2 text-muted">Rows per page:</span>
                                        <Form.Select
                                            size="sm"
                                            style={{ width: "80px" }}
                                            value={sizePerPage}
                                            onChange={(e) => {
                                                const newSize = parseInt(e.target.value);
                                                setSizePerPage(newSize);
                                                setPage(1);
                                                fetchLectures(selectedTab, 1); // reload from page 1 with new limit
                                            }}
                                        >
                                            <option value={5}>5</option>
                                            <option value={10}>10</option>
                                            <option value={20}>20</option>
                                            <option value={50}>50</option>
                                        </Form.Select>
                                    </div>

                                    {/* Right: Pagination */}
                                    <nav className="mt-2 mt-md-0">
                                        <ul className="pagination mb-0">
                                            {/* First page button */}
                                            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                                                <span
                                                    className="page-link"
                                                    style={{ cursor: page > 1 ? "pointer" : "default" }}
                                                    onClick={() => {
                                                        if (page > 1) {
                                                            setPage(1);
                                                            fetchLectures(selectedTab, 1);
                                                        }
                                                    }}
                                                >
                                                    &laquo;&laquo;
                                                </span>
                                            </li>

                                            {/* Previous button */}
                                            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                                                <span
                                                    className="page-link"
                                                    style={{ cursor: page > 1 ? "pointer" : "default" }}
                                                    onClick={() => {
                                                        if (page > 1) {
                                                            setPage(page - 1);
                                                            fetchLectures(selectedTab, page - 1);
                                                        }
                                                    }}
                                                >
                                                    &laquo;
                                                </span>
                                            </li>

                                            {/* Page numbers — show max 5 pages */}
                                            {(() => {
                                                const totalPages = Math.ceil(totalRecords / sizePerPage);
                                                const maxPagesToShow = 5;
                                                let start = Math.max(1, page - Math.floor(maxPagesToShow / 2));
                                                let end = Math.min(totalPages, start + maxPagesToShow - 1);

                                                if (end - start < maxPagesToShow - 1) {
                                                    start = Math.max(1, end - maxPagesToShow + 1);
                                                }

                                                const pages = [];
                                                for (let num = start; num <= end; num++) {
                                                    pages.push(
                                                        <li
                                                            key={num}
                                                            className={`page-item ${num === page ? "active" : ""}`}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <span
                                                                className="page-link"
                                                                onClick={() => {
                                                                    if (num !== page) {
                                                                        setPage(num);
                                                                        fetchLectures(selectedTab, num);
                                                                    }
                                                                }}
                                                            >
                                                                {num}
                                                            </span>
                                                        </li>
                                                    );
                                                }
                                                return pages;
                                            })()}

                                            {/* Next button */}
                                            <li className={`page-item ${page >= Math.ceil(totalRecords / sizePerPage) ? "disabled" : ""}`}>
                                                <span
                                                    className="page-link"
                                                    style={{
                                                        cursor:
                                                            page < Math.ceil(totalRecords / sizePerPage) ? "pointer" : "default",
                                                    }}
                                                    onClick={() => {
                                                        if (page < Math.ceil(totalRecords / sizePerPage)) {
                                                            setPage(page + 1);
                                                            fetchLectures(selectedTab, page + 1);
                                                        }
                                                    }}
                                                >
                                                    &raquo;
                                                </span>
                                            </li>

                                            {/* Last page button */}
                                            <li className={`page-item ${page >= Math.ceil(totalRecords / sizePerPage) ? "disabled" : ""}`}>
                                                <span
                                                    className="page-link"
                                                    style={{
                                                        cursor:
                                                            page < Math.ceil(totalRecords / sizePerPage) ? "pointer" : "default",
                                                    }}
                                                    onClick={() => {
                                                        if (page < Math.ceil(totalRecords / sizePerPage)) {
                                                            const totalPages = Math.ceil(totalRecords / sizePerPage);
                                                            setPage(totalPages);
                                                            fetchLectures(selectedTab, totalPages);
                                                        }
                                                    }}
                                                >
                                                    &raquo;&raquo;
                                                </span>
                                            </li>
                                        </ul>

                                    </nav>
                                </div>
                            )}

                        </>
                    ) : (
                        <p>No lectures found.</p>
                    )}
                </div>


                {/* Video Modal */}
                <Modal
                    show={showLiveModal}
                    onHide={() => setShowLiveModal(false)}
                    centered
                    size="lg"
                    dialogClassName="custom-lecture-modal"
                >
                    <Modal.Header closeButton className="border-0 py-3 modal-header-gradient">
                        <Modal.Title className="fw-semibold text-white fs-5">
                            SR LIVE Lecture
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="p-4">
                        {videoUrl ? (
                            <div className="video-container w-100 mt-3">
                                <VideoPlayer videoUrl={videoUrl} />
                            </div>
                        ) : (
                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                                <h5 className="mb-0 fw-semibold text-dark">
                                    {selectedLecture?.LectureTitle}
                                </h5>
                                <Button
                                    variant="primary"
                                    className="px-4 py-2 play-inline-btn d-flex align-items-center gap-2"
                                    onClick={handlePlayLecture}
                                >
                                    <FaPlay size={14} />
                                    <span>Play Lecture</span>
                                </Button>
                            </div>
                        )}
                    </Modal.Body>
                </Modal>


                {showRecordedModal && (
                    <VideoPlayModal
                        modalShow={showRecordedModal}
                        modalHide={() => setShowRecordedModal(false)}
                        otp={otp}
                        playbackInfo={playbackInfo}
                        AffiliateName={affname1}
                        Mobile={affmobile2}
                        emailid={affemail3}
                        lecturetitle={selectedLecture?.LectureTitle}
                    >
                        {playbackInfo && otp && (
                            <VideoCipherPlayer
                                otp={otp}
                                playbackInfo={playbackInfo}
                                AffiliateName={affname1}
                                Mobile={affmobile2}
                                emailid={affemail3}
                                ipaddress= {ipaddress}
                            />
                        )}
                    </VideoPlayModal>
                )}






            </div>
        </div>
    );
};

export default Lectures;
